import * as R from 'ramda'
import ApolloClient from 'apollo-boost'
import fetch from 'isomorphic-fetch'

export const createCheckoutState = (stores) => {
  return stores.reduce(
    (obj, { subdomain }) => ({
      ...obj,
      [subdomain]: {
        storeSubdomain: subdomain,
        id: null,
        webUrl: null,
        lineItems: { edges: [] },
        customAttributes: [],
      },
    }),
    {},
  )
}

export const validateStores = (stores) => {
  if (!(Array.isArray(stores) && stores.length > 0)) {
    throw new Error('No store is defined.')
  }

  if (stores.find(({ subdomain }) => !subdomain))
    throw new Error('"subdomain" is missing from one of the stores.')

  if (stores.find(({ storefrontAccessToken }) => !storefrontAccessToken))
    throw new Error(
      '"storefrontAccessToken" is missing from one of the stores.',
    )

  if (
    R.compose(
      R.not,
      R.equals(R.length(stores)),
      R.length,
      R.uniqBy(R.prop('subdomain')),
    )(stores)
  ) {
    throw new Error('Different stores share the same subdomain.')
  }
}

export const createShopifyStores = (stores) => {
  return stores.reduce(
    (accumulator, store) => ({
      ...accumulator,
      [store.subdomain]: {
        ...store,
        client: new ApolloClient({
          uri: `https://${store.customDomain}/api/2020-04/graphql.json`,
          // uri: `https://${store.subdomain}.myshopify.com/api/2020-04/graphql.json`,
          headers: {
            'X-Shopify-Storefront-Access-Token': store.storefrontAccessToken,
          },
          fetch, // after august 2021 we can uninstall isomorphic-fetch and replace with node-fetch; only reason for using isomorphic-fetch here is for IE, which will be discontinued at that time
        }),
      },
    }),
    {},
  )
}

export const getCustomDomains = (stores) =>
  stores.reduce(
    (obj, { subdomain, customDomain }) => ({
      ...obj,
      [subdomain]: customDomain ?? subdomain,
    }),
    {},
  )
